import { Selector } from './types';

export interface AsyncMetaState {
    hasFailed: boolean;
    isFetching: boolean;
}

type MetaSelector<S, P> = Selector<S, P, AsyncMetaState>;

const createAsyncMetaSelectors = <S, P>(metaSelector: MetaSelector<S, P>) => [
    (state: S, props?: P) => metaSelector(state, props as P).isFetching,
    (state: S, props?: P) => metaSelector(state, props as P).hasFailed,
];

export default createAsyncMetaSelectors;
